import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import SeamlessImmutable from 'seamless-immutable';
import { IGatewayDetailedDTO } from '../../repository/jago/model/input/IGatewayDetailedDTO';
import IGatewayInDTO from '../../repository/jago/model/input/IGatewayInDTO';
import { GatewaysActionsType } from './gateways.actions';
import GatewaysActionTypesEnum from './model/GatewaysActionTypesEnum';
import { IGatewayArtifactInDTO } from '../../repository/jago/model/input/IGatewayArtifactInDTO';
import { IGatewayDeploymentInDTO } from '../../repository/jago/model/input/IGatewayDeploymentInDTO';
import { IGatewayDeploymentDetailedInDTO } from '../../repository/jago/model/input/IGatewayDeploymentDetailedInDTO';
import IGatewayLogEntryDTO from '../../repository/jago/model/input/IGatewayLogEntryDTO';

export interface IGatewayLogsStateSlice {
  entries: IGatewayLogEntryDTO[];
  loading: boolean;
  errorMessageKey: string | null;
}

export interface IGatewaysInterface {
  gateways: PaginatedDataDTO<IGatewayInDTO> | {};
  artifacts: PaginatedDataDTO<IGatewayArtifactInDTO> | {};
  deployments: PaginatedDataDTO<IGatewayDeploymentInDTO> | {};
  selectedDetailedGateway: IGatewayDetailedDTO | {};
  selectedDetailedDeployment: IGatewayDeploymentDetailedInDTO | {};
  gatewayLogs: IGatewayLogsStateSlice;
}

const initialGatewayLogs: IGatewayLogsStateSlice = {
  entries: [],
  loading: false,
  errorMessageKey: null,
};

const initialState = SeamlessImmutable<IGatewaysInterface>({
  gateways: {},
  artifacts: {},
  deployments: {},
  selectedDetailedGateway: {},
  selectedDetailedDeployment: {},
  gatewayLogs: initialGatewayLogs,
});

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state: SeamlessImmutable.ImmutableObject<IGatewaysInterface> = initialState, action: GatewaysActionsType) {
  switch (action.type) {
    case GatewaysActionTypesEnum.SAVE_GATEWAYS:
      return state.set('gateways', action.payload);
    case GatewaysActionTypesEnum.SAVE_GATEWAYS_ARTIFACTS:
      return state.set('artifacts', action.payload);
    case GatewaysActionTypesEnum.SAVE_GATEWAYS_DEPLOYMENTS:
      return state.set('deployments', action.payload);
    case GatewaysActionTypesEnum.SET_SELECTED_DETAILED_GATEWAY:
      return state.set('selectedDetailedGateway', action.payload);
    case GatewaysActionTypesEnum.SET_SELECTED_DETAILED_DEPLOYMENT:
      return state.set('selectedDetailedDeployment', action.payload);
    case GatewaysActionTypesEnum.SET_GATEWAY_LOGS_LOADING:
      if (action.payload === true) {
        return state.setIn(['gatewayLogs', 'loading'], true).setIn(['gatewayLogs', 'errorMessageKey'], null);
      }
      return state.setIn(['gatewayLogs', 'loading'], false);
    case GatewaysActionTypesEnum.SET_GATEWAY_LOGS_SUCCESS:
      return state
        .setIn(['gatewayLogs', 'entries'], action.payload)
        .setIn(['gatewayLogs', 'loading'], false)
        .setIn(['gatewayLogs', 'errorMessageKey'], null);
    case GatewaysActionTypesEnum.SET_GATEWAY_LOGS_ERROR:
      return state
        .setIn(['gatewayLogs', 'errorMessageKey'], action.payload)
        .setIn(['gatewayLogs', 'loading'], false)
        .setIn(['gatewayLogs', 'entries'], []);
    case GatewaysActionTypesEnum.CLEAR_GATEWAY_LOGS:
      return state.set('gatewayLogs', initialGatewayLogs);
    default:
      return state;
  }
}
